import { AttributesMixin, define, Model } from "@type-r/models";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";

export interface ValidationResponse {
    isValid: boolean,
    errors: string[]
}

export interface ValidationRuleValidation extends AttributesMixin<typeof ValidationRuleValidation> { }

@define
export class ValidationRuleValidation extends Model {
    static endpoint = restfulIO('api/v1/ingest/validation-rules/validate');
}

export async function validation(id, name, assetTypeId): Promise<ValidationResponse> {
    let url: string = `api/v1/ingest/validation-rules/validate`;
    let payload = {
        name,
        assetTypeId
    };
    if (id) {
        payload = { ...payload, ...{ id } }
    }

    return (await fetch(url, {
        method: 'POST',
        headers: new Headers({
            "Authorization": getAuthorizationBearer(),
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Platform-Code': getPlatformCode()
        }),
        body: JSON.stringify(payload)
    })).json();
}
